module.exports = __webpack_public_path__ + "img/renfield_Small.fe81cc97.png";